export default __webpack_public_path__ + "static/english-forms-ed8066a4dd5b3f9fbc700a57cb1d03da.pdf";